import React, { useState } from 'react';
import { Lock, Mail, AlertCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem('admin_token', data.token);
        onLogin(data);
      } else {
        const data = await res.json();
        setError(typeof data.detail === 'string' ? data.detail : 'Anmeldung fehlgeschlagen');
      }
    } catch {
      setError('Verbindungsfehler');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-[#ff84e4]/10 flex items-center justify-center">
            <Lock className="w-7 h-7 text-[#ff84e4]" />
          </div>
          <h1 className="text-2xl font-bold text-white">Admin Login</h1>
          <p className="text-gray-500 text-sm mt-1">Northlight Visuals</p>
        </div>

        {error && (
          <div className="mb-4 p-3 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center gap-2">
            <AlertCircle className="w-4 h-4 text-red-400 flex-shrink-0" />
            <p className="text-red-300 text-sm">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm text-gray-500 mb-2 flex items-center gap-2">
              <Mail className="w-4 h-4" /> E-Mail
            </label>
            <input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 rounded-xl bg-white/[0.03] border border-white/[0.08] text-white placeholder-gray-600 focus:border-[#ff84e4]/40 focus:outline-none focus:ring-1 focus:ring-[#ff84e4]/40 text-sm"
              placeholder="admin@northlight-visuals.de"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-500 mb-2 flex items-center gap-2">
              <Lock className="w-4 h-4" /> Passwort
            </label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full px-4 py-3 rounded-xl bg-white/[0.03] border border-white/[0.08] text-white placeholder-gray-600 focus:border-[#ff84e4]/40 focus:outline-none focus:ring-1 focus:ring-[#ff84e4]/40 text-sm"
            />
          </div>
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full py-3.5 rounded-full font-semibold text-sm bg-[#ff84e4] text-black hover:bg-[#ffd1e7] transition-colors duration-200"
          >
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
